module.exports = __webpack_public_path__ + "img/invalid@3x.72d35663.png";